/*
 * Notificações recolhidas pelo usuário na tela das notificações.
 *
 * Recolher é só uma preferência de apresentação de cada pessoa, por isso fica guardado no navegador (localStorage),
 * por usuário, e não no banco. Se o navegador não permitir guardar, as notificações aparecem abertas, sem erro.
 */

//Qtde máxima de notificações recolhidas guardadas (as mais antigas saem da lista)
export const MAX_NOTIFICACOES_RECOLHIDAS = 500;

//Chave do navegador com as notificações recolhidas do usuário
function fn_getChaveNotificacoesRecolhidas(idUsuario) {
  return `siig-notificacoes-recolhidas-${idUsuario}`;
}

//Retorna os ids (string) das notificações do usuário recolhidas neste navegador
export function fn_getNotificacoesRecolhidas(idUsuario) {
  try {
    const valor = localStorage.getItem(
      fn_getChaveNotificacoesRecolhidas(idUsuario),
    );
    const ids = valor ? JSON.parse(valor) : [];

    return Array.isArray(ids) ? ids.map(String) : [];
  } catch {
    return [];
  }
}

//Guarda no navegador as notificações recolhidas do usuário (mantém as últimas MAX_NOTIFICACOES_RECOLHIDAS)
export function fn_salvarNotificacoesRecolhidas(idUsuario, ids) {
  try {
    localStorage.setItem(
      fn_getChaveNotificacoesRecolhidas(idUsuario),
      JSON.stringify(ids.slice(-MAX_NOTIFICACOES_RECOLHIDAS)),
    );
  } catch {
    //Navegador sem permissão para guardar (ex: bloqueio de dados do site): as notificações voltam abertas, sem erro
  }
}

/*
 * Retorna a lista de recolhidas com as notificações informadas recolhidas (true) ou abertas (false)
 * @ids: ids das notificações a recolher ou abrir
 */
export function fn_alterarNotificacoesRecolhidas(recolhidas, ids, recolher) {
  const idsAlterar = ids.map(String);
  const semAlterar = recolhidas.filter((id) => !idsAlterar.includes(id));

  return recolher ? [...semAlterar, ...idsAlterar] : semAlterar;
}
